const { REGION, COUNTRIES_BY_REGION } = require('../constants/regions');

const RE_COUNTRY_CODE = /^[A-Z]{2}$/;

const REGION_BY_COUNTRY_CODE = {};
const REGION_BY_COUNTRY_NAME = {};

Object.entries(COUNTRIES_BY_REGION).forEach(([region, countries]) => {
    countries.forEach(([code, names]) => {
        REGION_BY_COUNTRY_CODE[code] = region;
        names.forEach((name) => {
            REGION_BY_COUNTRY_NAME[name.toLowerCase()] = region;
        });
    });
});

const normalize = (value) => (typeof value === 'string' ? value.trim() : '');

// A listed English name or any ISO code resolves a region; an unrecognised name (e.g. localised) stays unknown.
const getDestinationRegion = (country, countryCode) => {
    const code = normalize(countryCode).toUpperCase();
    if (RE_COUNTRY_CODE.test(code)) {
        return REGION_BY_COUNTRY_CODE[code] || REGION.OTHER;
    }

    return REGION_BY_COUNTRY_NAME[normalize(country).toLowerCase()] || null;
};

module.exports = {
    getDestinationRegion
};
